import { IPartnerEnrollmentRequest, PartnerEnrollment } from '../contracts';
import LogCannon from '@ace-clublabs/log-cannon';
import axios, { AxiosResponse } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import CookieHelper from '../../utils/cookieHelper';

export const PartnerEnrollmentApi =
  (endpoint: string): PartnerEnrollment =>
  async ({ sessionId, partnerEnrollments }: IPartnerEnrollmentRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');

      if (!sessionId) {
        return Promise.resolve({ success: false });
      }

      const response = await axios.post(
        endpoint,
        { sessionId, partnerEnrollments },
        createAxiosConfig(scenario, endpoint)
      );
      LogCannon.blast('PartnerEnrollmentApi success');
      return Promise.resolve({ success: true, data: response?.data });
    } catch (e: any) {
      if (e.response) {
        const message = e?.response?.data?.error?.message;
        const error_code = e?.response?.data?.error?.error_code;
        return Promise.resolve({ success: false, message, error_code });
      }
      return Promise.resolve({ success: false });
    }
  };
